import { Suspense, lazy, useState } from "react";
import { useAuth, AUTH_MODE } from "../lib/auth";
import { Loading } from "../components/DataState";
import { c, font } from "../lib/theme";

// Clerk's hosted sign-in lives in the lazy auth-clerk chunk — only fetched in
// clerk mode, so the default local build never ships the Clerk SDK.
const ClerkSignIn = lazy(() => import("../lib/auth-clerk").then((m) => ({ default: m.ClerkSignIn })));

export function Login() {
  // CLERK mode: delegate to Clerk's hosted sign-in (handles password, MFA,
  // reset, email verification).
  if (AUTH_MODE === "clerk") {
    return (
      <div style={{ display: "grid", placeItems: "center", height: "100%" }}>
        <Suspense fallback={<Loading label="Loading sign-in" />}>
          <ClerkSignIn />
        </Suspense>
      </div>
    );
  }

  return <LocalLogin />;
}

// LOCAL mode: the dev-shim email/password form.
function LocalLogin() {
  const { login } = useAuth();
  const [email, setEmail] = useState("troy@vetsllc.org");
  const [password, setPassword] = useState("Admin!2026");
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent): Promise<void> => {
    e.preventDefault();
    setBusy(true); setErr(null);
    try { await login(email, password); }
    catch { setErr("Invalid credentials."); }
    finally { setBusy(false); }
  };

  const input: React.CSSProperties = { width: "100%", background: c.soft.tile, border: "none", borderRadius: 8, padding: "11px 12px", color: c.textHi, fontSize: 15, outline: "none", marginBottom: 12 };

  return (
    <div style={{ display: "grid", placeItems: "center", height: "100%" }}>
      <form onSubmit={submit} style={{ width: 360, background: c.panel, border: `1px solid ${c.line}`, borderRadius: 8, padding: 28 }}>
        <div style={{ font: `700 25px ${font.display}`, color: c.textHi, letterSpacing: "-0.01em", marginBottom: 4 }}>ArcLine</div>
        <div style={{ font: `600 12.5px ${font.sans}`, letterSpacing: "0.04em", color: c.muted, marginBottom: 22 }}>PRODUCTION LINE · SIGN IN</div>
        <input style={input} value={email} onChange={(e) => setEmail(e.target.value)} placeholder="email" autoComplete="username" />
        <input style={input} type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="password" autoComplete="current-password" />
        {err && <div style={{ color: c.redHi, fontSize: 14, marginBottom: 10 }}>{err}</div>}
        <button disabled={busy} style={{ width: "100%", background: c.red, color: c.onAccent, border: "none", borderRadius: 7, padding: "11px", font: `600 12.5px ${font.sans}`, letterSpacing: "0.04em", cursor: "pointer", opacity: busy ? 0.6 : 1 }}>
          {busy ? "…" : "SIGN IN"}
        </button>
        <div style={{ marginTop: 16, fontSize: 13, color: c.muted, lineHeight: 1.6 }}>
          Dev accounts: troy (admin) · partner · analyst · compliance @vetsllc.org<br />
          RBAC is server-enforced — sign in as compliance to see read-only lockouts.
        </div>
      </form>
    </div>
  );
}
